import { Helmet } from "react-helmet-async";
import "./Office.css";
import "../../ParafiaWizytowka.css";
import { year, holiday, officeImage, items, itemDetails } from "../../data/officeData.js";
import Divider from "../../components/Divider/Divider.js";

const Office = ({ onSelectItem }) => {

  const getOfficeHoursDescription = () => {
    let description = `Godziny otwarcia kancelarii parafialnej św. Urszuli Ledóchowskiej w Częstochowie. `;

    if (Array.isArray(year) && year.length > 0) {
      description += `${year.join(", ")}. `;
    } else if (typeof year === "string" && year) {
      description += `${year}. `;
    }

    if (Array.isArray(holiday) && holiday.length > 0) {
      description += `W święta: ${holiday.join(", ")}. `;
    } else if (typeof holiday === "string" && holiday) {
      description += `W święta: ${holiday}. `;
    }

    description +=
      "Adres: ul. Gajowa 39/41, Częstochowa. Zapraszamy w sprawie intencji, ślubów, chrztów i innych spraw parafialnych.";

    return description;
  };

  const renderYear = () => {
    if (Array.isArray(year)) {
      return year.map((item, idx) => (
        <p key={idx} className="office-text">
          {item}
        </p>
      ));
    } else if (typeof year === "string") {
      return <p className="office-text">{year}</p>;
    }
    return null;
  };

  const renderHoliday = () => {
    if (Array.isArray(holiday)) {
      return holiday.map((item, idx) => (
        <p key={idx} className="office-text">
          {item}
        </p>
      ));
    } else if (typeof holiday === "string") {
      return <p className="office-text">{holiday}</p>;
    }
    return null;
  };

  const handleItemClick = (item) => {
  if (onSelectItem) {
    const details = itemDetails[item.id] || item;
    onSelectItem(details, item.slug);
  }
};

  return (
    <>
      <Helmet>
        <title>
          Kancelaria parafialna – Parafia św. Urszuli Ledóchowskiej w
          Częstochowie
        </title>
        <meta name="description" content={getOfficeHoursDescription()} />
        <meta
          name="keywords"
          content="kancelaria parafialna, godziny otwarcia kancelarii, sprawy parafialne, intencje mszy św., ślub, chrzest, pogrzeb, parafia Częstochowa, św. Urszula Ledóchowska, Wrzosowiak"
        />
        <meta
          property="og:title"
          content="Kancelaria parafialna – Parafia św. Urszuli Ledóchowskiej"
        />
        <meta
          property="og:description"
          content={`Kancelaria parafialna św. Urszuli Ledóchowskiej. ${
            Array.isArray(year) ? year.join(", ") : year || "Sprawdź godziny otwarcia"
          }.`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://swurszula.pl/kancelaria" />
        <meta property="og:image" content={officeImage} />
        <meta
          property="og:image:alt"
          content="Kancelaria parafialna św. Urszuli Ledóchowskiej"
        />
        <meta property="og:locale" content="pl_PL" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Kancelaria parafialna – Parafia św. Urszuli Ledóchowskiej"
        />
        <meta
          name="twitter:description"
          content={`Godziny otwarcia kancelarii: ${
            Array.isArray(year) ? year.join(", ") : year || "sprawdź na stronie"
          }.`}
        />
        <meta name="twitter:image" content={officeImage} />
      </Helmet>

      <section className="officeCard">
        <img
          src={officeImage}
          alt="Kancelaria parafialna św. Urszuli Ledóchowskiej w Częstochowie"
          className="image"
        />

        <h2 className="section-title">Kancelaria parafialna</h2>

        {renderYear()}
        {renderHoliday()}
      </section>
    </>
  );
};

export default Office;